import {
  searchProductsByQuery,
  searchProductsById,
  searchCombinationByIds,
  idDev,
} from "./api";
import axios from "axios";
import bxlUtils from "bxl-utils";
import { DEVICE_ID, BASE_HOST } from "../lib/constants";
import { platform } from "../lib/platform";

const channel = window.location.host.split(".")[0];

const http = axios.create({
  baseURL: BASE_HOST[channel]
    ? BASE_HOST[channel]
    : "https://5thave-prod.bieyangapp.com",
});
http.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      "X-Session-DeviceID": localStorage.getItem(DEVICE_ID) || "",
      "X-BXL-User-Agent": `Bieyang H5WB/${platform} 0.1.0 (${bxlUtils.platform.getOS()} ${bxlUtils.platform.getVersion()}; UID )${channel}`,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export const getProductsById = (productIds) => {
  return http.post(searchProductsById, {
    productIds,
  });
};

export const searchProducts = (query) => {
  return http.post(
    searchProductsByQuery,
    {
      q: bxlUtils.uri.stringify({
        ...query,
        aggr: false,
      }),
    },
    {
      headers: {
        "Content-Type": "application/x-protobuf-json",
      },
    }
  );
};

export const getCampaignContent = (url: string) => {
  url =
    url.trim().replace(/index.html/gi, "content.json") +
    `?t=${new Date().getTime()}`;
  return axios.get(url);
};

export const getCombinationByIds = (ids: string[] = []) => {
  return http.post(
    searchCombinationByIds,
    {
      combinationIds: ids,
    },
    {
      baseURL: `https://tapestry-prod.bybieyang.com`,
    }
  );
};